import get from 'lodash/get';
import { DEFAULT_TRACKING_DATA } from "../../constants/index.js";
$ const isWatched = get(state, 'isWatched', false);
$ const watchCount = get(state, 'watchCount', () => '');
$ const animationType = get(state, 'animationType');
$ const a11yText = get(input, 'a11yText', '');
$ const itemHeartAriaLabel = typeof a11yText === 'function' ? a11yText(isWatched) : a11yText;
$ const ariaPressed = get(state, 'isWatched', false) ? 'true' : 'false';
$ const itemDetails = get(input, 'itemDetails', {
  itemData: {
    isMSKU: false,
    isWatched: false,
    watchCount: () => '',
    itemId: ''
  }
});
$ const showAddToListDialog = get(state, 'showAddToListDialog', false);
$ const showSkuSelector = get(state, 'showSkuSelector', false);
$ const trackingData = get(input, 'trackingData', DEFAULT_TRACKING_DATA);
$ const addToWatchTrackingData = get(input, 'addToWatchTrackingData', DEFAULT_TRACKING_DATA);
$ const watchHeartSize = get(input, 'watchHeartSize', 'sm');
$ const snackbarData = {
  snackbar: get(state, 'snackbar', {
    content: '',
    open: false,
    actionLinkText: ''
  }),
  isError: get(state, 'isError', false),
  responseType: get(state, 'responseType', ''),
  hostname: get(input, 'watchDataProvider.apiSettings.hostname', '')
};
<ebay-icon-button key="favHeart" on-click("onHeartClick") class=["fav-heart", animationType] size="small" aria-label=itemHeartAriaLabel aria-pressed=ariaPressed>
  <span key='favHeartCount' class="fav-heart__count" hidden=(input.animationType === 'nudge')>
    ${watchCount(isWatched)}
  </span>
  <if(watchHeartSize === 'md')>
    <if(isWatched)>
      <ebay-heart-filled-20-icon/>
    </if>
    <else>
      <ebay-heart-20-icon/>
    </else>
  </if>
  <else>
    <if(isWatched)>
      <ebay-heart-filled-16-icon/>
    </if>
    <else>
      <ebay-heart-16-icon/>
    </else>
  </else>
</ebay-icon-button>
<favorite-snackbar-dialog ...snackbarData onSnackbarClose("onSnackbarClose")/>
<if(showAddToListDialog && input.addToListLocalizedContent)>
  <add-to-list-dialog open=showAddToListDialog itemDetails=itemDetails localizedContent=input.addToListLocalizedContent watchDataProvider=input.watchDataProvider trackingData=trackingData addToWatchTrackingData=addToWatchTrackingData on-toast('handleAddToListToast') on-open('handleOpenAddToListDialog') on-close('handleCloseAddToListDialog') on-redirect('handleRedirectURL')/>
</if>
<if(showSkuSelector && input.skuSelectorLocalizedContent)>
  <sku-selector open=showSkuSelector itemDetails=itemDetails watchDataProvider=input.watchDataProvider localizedContent=input.skuSelectorLocalizedContent trackingInfo=trackingData on-open('handleOpenSkuSelector') on-close('handleCloseSkuSelector') on-done('handleSkuSelectorDone') on-toast('handleSkuSelectorToast')/>
</if>